import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { BasicXpacInfo, CrossNetDevice } from 'src/app/generated/CrossPoint.RemoteXpac.Server';
import { getXpacDevicesAction } from 'src/app/store/actions/devices.actions';
import { selectXpacDevices } from 'src/app/store/selectors/devices.selectors';
import { hasValue } from 'src/app/angular-core/utils/functions/common.functions';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { getTranslationKeyForValue } from 'src/app/angular-core/utils/functions/translation.functions';
import { compare } from 'src/app/utils/functions/common.functions';

@UntilDestroy()
@Component({
  selector: 'xpac-devices',
  templateUrl: './xpac-devices.component.html',
  styleUrls: ['./xpac-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpacDevicesComponent implements OnInit {
  public isLoading: boolean = true;
  
  @Input() public xpac: BasicXpacInfo = null;

  public devices: CrossNetDevice[] = null;
  
  constructor(
    private store: Store<IRemoteXPACPortalState>,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.initListeners();
    this.store.dispatch(getXpacDevicesAction({ data: this.xpac.deviceId }));
  }

  public getDeviceTitle(device: CrossNetDevice): string {
    return this.translate.instant(`DeviceTypes.${getTranslationKeyForValue(device.deviceType)}`);
  }

  public getDeviceInfo(device: CrossNetDevice): string {
    return `${device.mac} - ${device.firmware}`;
  }

  private initListeners(): void {
    this.store.select(selectXpacDevices(this.xpac.deviceId))
      .pipe(
        filter(hasValue),
        untilDestroyed(this)
      )
      .subscribe((xpacDevices) => {
        this.devices = [...xpacDevices.devices];
        this.devices.sort((a, b) => compare(a.deviceType, b.deviceType) * 10 + compare(a.mac, b.mac))
        this.isLoading = false;
        this.cdr.markForCheck();
      });
  }
}